export default function Hero() {
  const stats = [
    { value: '50万+', label: '高清资源' },
    { value: '99.9%', label: '播放流畅率' },
    { value: '24h', label: '持续更新' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20digital%20entertainment%20background%20with%20soft%20flowing%20gradients%20in%20coral%20and%20golden%20tones%2C%20smooth%20organic%20shapes%2C%20cinematic%20lighting%2C%20modern%20streaming%20platform%20aesthetic%2C%20clean%20minimal%20composition%20with%20subtle%20texture%2C%20warm%20atmosphere%2C%208k%20quality%20digital%20art&width=1600&height=900&seq=hero-bg-zhainan&orientation=landscape"
          alt="宅男视频数字视频平台背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-0">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-800 whitespace-nowrap">
                <i className="ri-fire-line mr-1"></i>91视频
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                <i className="ri-flashlight-line mr-1"></i>97视频
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary-200 text-secondary-800 whitespace-nowrap">
                51视频网站
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              宅男视频
              <span className="block text-primary-500 mt-1">海量高清视频在线观看平台</span>
            </h1>

            <p className="mt-3 text-lg md:text-xl text-foreground-600 font-light">
              免费高清 · 流畅不卡顿 · 随时畅享
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              宅男视频作为领先的数字视频平台，全面覆盖91视频、97视频及51视频网站等主流数字品牌在线入口。平台汇聚海量免费高清资源，采用先进的视频传输技术确保播放流畅不缓冲，为用户打造极致的在线观看体验。每日持续更新热门内容，让每一次点击都能直达精彩。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mt-7">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                    {stat.value}
                  </p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-md border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 hover:border-background-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                下载客户端
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] sm:w-[340px] sm:h-[460px] md:w-[400px] md:h-[540px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20mockup%20displaying%20video%20content%20thumbnails%20with%20warm%20coral%20and%20golden%20accents%2C%20sleek%20dark%20UI%20design%20with%20play%20buttons%2C%20content%20grid%20layout%2C%20cinematic%20atmosphere%2C%20clean%20modern%20mobile%20app%20style%2C%20high%20contrast%2C%20professional%20product%20rendering&width=800&height=1100&seq=hero-visual-zhainan&orientation=portrait"
                alt="宅男视频平台界面展示"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4 md:p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-background-50 text-sm font-medium">宅男视频 · 正在热播</p>
                    <div className="flex items-center gap-2 mt-1">
                      <div className="h-1 flex-1 bg-background-50/30 rounded-full overflow-hidden">
                        <div className="h-full w-3/5 bg-primary-500 rounded-full"></div>
                      </div>
                      <span className="text-background-50/70 text-xs">36:42</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}